import { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { Institutional } from "@/components/site/Institutional";
import { Services } from "@/components/site/Services";
import { Differentials } from "@/components/site/Differentials";
import { Owners } from "@/components/site/Owners";
import { Tenants } from "@/components/site/Tenants";
import { Footer } from "@/components/site/Footer";
import { ContactModal } from "@/components/site/ContactModal";
import { FloatingWhatsApp } from "@/components/site/FloatingWhatsApp";

const Home = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalType, setModalType] = useState("encontrar");

  const openEncontrar = () => {
    setModalType("encontrar");
    setModalOpen(true);
  };

  const openAnunciar = () => {
    setModalType("anunciar");
    setModalOpen(true);
  };

  return (
    <div className="App" data-testid="home-page">
      <div className="noise-overlay" aria-hidden="true" />
      <Navbar onOpenAnunciar={openAnunciar} />
      <main className="relative z-[2]">
        <Hero onOpenEncontrar={openEncontrar} onOpenAnunciar={openAnunciar} />
        <Institutional />
        <Services />
        <Differentials />
        <Owners onOpenAnunciar={openAnunciar} />
        <Tenants onOpenEncontrar={openEncontrar} />
      </main>
      <Footer />
      <FloatingWhatsApp />
      <ContactModal open={modalOpen} onClose={() => setModalOpen(false)} type={modalType} />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
